import * as types from '../actionType'

const initialState = []

export const faqRedu = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_FAQ:
            return action.payload
        default:
            return state
    }
}